import { FormCheckbox } from "@/components/forms/FormCheckbox";
import { Heading } from "@/components/typography";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { DialogHeader, DialogTitle } from "@/components/ui/dialog";

type RejectRemainingDialogProps = {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    rejectPitched: boolean;
    onRejectPitchedChange: (checked: boolean) => void;
    rejectNeedsInfo: boolean;
    onRejectNeedsInfoChange: (checked: boolean) => void;
    actionPending: boolean;
    onConfirm: () => void;
    onCancel: () => void;
};

/** Confirm rejecting leftover pitched and/or needs-info pitches. */
export function RejectRemainingDialog({
    open,
    onOpenChange,
    rejectPitched,
    onRejectPitchedChange,
    rejectNeedsInfo,
    onRejectNeedsInfoChange,
    actionPending,
    onConfirm,
    onCancel,
}: RejectRemainingDialogProps) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-md" showCloseButton={false}>
                <DialogHeader>
                    <DialogTitle render={<Heading type="h3" tag="h2" />}>
                        Reject remaining pitches?
                    </DialogTitle>
                    <DialogDescription className="text-foreground">
                        This sets the selected open pitches to Rejected.
                        Bookings from accepted pitches are not affected.
                    </DialogDescription>
                </DialogHeader>
                <FormCheckbox
                    label="Pitched"
                    checked={rejectPitched}
                    onChange={onRejectPitchedChange}
                />
                <FormCheckbox
                    label="Needs info"
                    checked={rejectNeedsInfo}
                    onChange={onRejectNeedsInfoChange}
                />
                {/* Side-by-side confirm and cancel, matching Lists delete. */}
                <DialogFooter className="sm:justify-stretch">
                    <Button
                        variant="destructive"
                        className="flex-1"
                        disabled={actionPending || (!rejectPitched && !rejectNeedsInfo)}
                        onClick={onConfirm}
                    >
                        Reject remaining
                    </Button>
                    <Button
                        variant="secondary"
                        className="flex-1"
                        disabled={actionPending}
                        onClick={onCancel}
                    >
                        Back to Safety
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
